<div *ngIf="!url" class="d-flex justify-content-center align-items-center" style="{{style}}">Heic-file loading..</div>
<img [attr.id]="fileId" [src]="url" style="{{style}}" [ngClass]="class" alt="" *ngIf="url"/>
